import * as React from 'react';
import * as styles from './PageTitle.css';
import { Link } from '../Link';

interface IPageTitleProps {
  newbuildingName: string;
  newbuildingUrl: string;
}
export const PageTitle = (props: IPageTitleProps) => {
  const intro = 'Ипотека в ';

  return (
    <h1 className={styles['title']}>
      {intro}
      <Link target="_blank" url={props.newbuildingUrl}>
        {props.newbuildingName}
      </Link>
    </h1>
  );
};
